export function getPanelDescription(type) {
    switch (type) {
        case 'project-list':
            return 'Project List Panel.';
        case 'services':
            return 'Sevices List Panel.';
        case 'newsletter':
            return 'Newsletter Panel.';
        
        default:
            return 'Create a custom panel';
    }
}

export function getPanelImage(type) {
    switch (type) {
        case 'project-list':
            return '/icons/Panel Type/Columns/Grid View 3 Col@2x.png';
        case 'services':
            return '/icons/Panel Type/Columns/Grid View 3 Col@2x.png';
        case 'newsletter':
            return '/icons/Panel Type/Columns/Grid View 3 Col@2x.png';
        
        
        default:
            return '/icons/Panel Type/General/Default@2x.png';
    }
}

export function getPanelSmallImage(type) {
    switch (type) {
        case 'project-list':
            return '/icons/Panel Type/Columns/Grid View 3 Col.png';
        case 'services':
            return '/icons/Panel Type/Columns/Grid View 3 Col.png';
        case 'newsletter':
            return '/icons/Panel Type/Columns/Grid View 3 Col.png';
        
        default:
            return '/icons/Panel Type/General/Default.png';
    }
}

export function getPanelLabel(type) {
    switch (type) {
        case 'project-list':
            return 'Project List';
        case 'services':
            return 'Service List';
        case 'newsletter':
            return 'Newsletter List';
        
        default:
            return type;
    }
}

export function getPanelOptions(types) {
    return _.chain(types)
        .map(type => ({
            id: type,
            name: getPanelLabel(type),
            image: getPanelImage(type),
            description: getPanelDescription(type),
        }))
        .value();
}

export default {
    getPanelLabel,
    getPanelOptions,
    getPanelDescription,
    getPanelImage,
    getPanelSmallImage,
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/utils.js